import React from 'react';
import { useState ,useEffect,useMemo, useRef} from "react";
import Swal from "sweetalert2";
import {Row,Col,Button} from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import {useLocation,Link} from 'react-router-dom';
import {displayErrorToast,parseBoolean,displayError} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { default as ReactSelect } from "react-select";
import { getCompanyDetails} from '../../services/CompanyServices';
import { getAllCustomerMain, getCustomerMainDetails} from '../../services/CustomerMainServices';
import { getCurrentDate, getCurrentTime} from '../../utils/DateUtils';
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import SummaryIcon from '../../components/SummaryIcon';
import QuestionIcon from '../../components/QuestionIcon';
import DmixIcon from '../../components/DmixIcon';
import { getSalesOrdersForWorkSchedule } from '../../services/SalesOrderServices';
import { getCustomerSiteDetails } from '../../services/CustomerSiteServices';
import { createWorkSchedule,getWorkScheduleJobNumber} from '../../services/WorkScheduleServices';
import { getDisplayDate } from '../../utils/DateUtils';
import ReactTablePopUpSubmitWrapper from "../../components/ReactTablePopUpSubmitWrapper";
import ViewOnlyTextbox from '../../components/ViewOnlyTextbox';
import StatusDropDown from '../../components/StatusDropDown';
import { getDefaultDesignMix } from '../../services/DesignMixServices';
import { getAllPlantConfigurations } from '../../services/PlantConfigurationServices';
import {  showDmixPopup } from '../dispatch/DeliveryChallanUtils';
import ListFormPageHeader from '../../components/ListFormPageHeader';
import { GradientCard } from '../../components/ListPageGradientSummary';
import { buildGradientCard, formatQty } from '../../utils/listSummaryUtils';

const getFinishedGoodsLines = (salesorder) =>
    (salesorder.order_list || []).filter(
        (order) => order.product?.category?.name === 'FINISHED GOODS'
    );

const buildSalesOrderPopupRows = (salesorder) => {
    const finishedLines = getFinishedGoodsLines(salesorder);
    return finishedLines.map((order) => ({
        id: order.id,
        salesorder_id: salesorder.id,
        order_no: `${salesorder.prefix || ''}${salesorder.order_no || ''}`,
        order_date: getDisplayDate(salesorder.order_date),
        customer_name: salesorder.consignee?.customer?.name ?? '',
        consignee_name: salesorder.consignee?.project_name ?? '',
        company: salesorder.company?.name ?? '',
        prefix: salesorder.prefix,
        validity_date: getDisplayDate(salesorder.validity_date),
        grade: order.product?.name || '',
        delivery_mode: (order.delivery_mode || '').toUpperCase(),
        order_qty: formatQty(order.quantity),
        balance_qty: formatQty(
            (parseFloat(order.quantity) || 0) - (parseFloat(order.delivered_qty) || 0)
        ),
    }));
};

const buildSalesOrderPopupRow = buildSalesOrderPopupRows;

const findSalesOrderLine = (salesOrders, salesOrderDetailId) => {
    for (const salesorder of salesOrders) {
        const line = getFinishedGoodsLines(salesorder).find((order) => order.id == salesOrderDetailId);
        if (line) {
            return { salesorder, line };
        }
    }
    return { salesorder: null, line: null };
};

function WorkSchedule() {
    const [plantConfig,setPlantConfig] = React.useState({});
    const [designMixList,setDesignMixList] = React.useState({});
    const initial_table_data = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(initial_table_data);
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const [cookies] = useCookies(['myToken']);
    const [category] = useCookies(['myCategory']);
    const [inProgress, setInProgress] = useState(false);
    const [superuser] = useCookies(['mySuperuser']);
    const [inputs, setInputs] = useState({});
    const [filteredplants,setFilteredPlants] = useState([]);
    const [products, setProducts] = React.useState([]);
    const [error, setError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [salesorders,setSalesorders]=React.useState([]);
    const [selectedSalesOrder,setSelectedSalesOrder] = useState({});
    const [deliverymodes,setDeliveryModes] = useState([]);
    const [allSalesOrders,setAllSalesOrders] = useState([]);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [plants, setPlant] = React.useState([]);
    const [companyId] = useCookies(['myCompanyId']);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomerOption, setSelectedCustomerOption] = useState(null);
    const salesOrderCacheRef = useRef({});
    
    
    React.useEffect(() => {
        // var tomorrow = new Date();
        // tomorrow.setDate(tomorrow.getDate() + 1);
        // var formattedTomorrow = tomorrow.toISOString().split('T')[0];
        setInputs(values => ({...values,
            ['schedule_date']: getCurrentDate(), 
            ['delivery_date']: getCurrentDate(),
            ['delivery_time']: getCurrentTime(),
            ['is_extra_shut_required']:'false',
            ['cube_mould_test_place']:'plant',
            ['is_name_req']:'false',
            // ['validity_date']: formattedTomorrow
        }))
    }, []);

    React.useEffect(() => {
        getAllCustomerMain(cookies, '', true)
            .then(customerList => {
                const options = (customerList.customer_list || [])
                    .filter(cust => cust.status)
                    .map(cust => ({ value: cust.id, label: cust.name }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setCustomers(options);
            })
            .catch((error) => {
                displayError(error.response?.data ?? error.message, 'Failed to load customers');
            });
    }, []);
      
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        try{
            setInputs(values => ({...values, [name]: value}));
            if(name === 'plant_id' && value){
                setInProgress(true);
                getWorkScheduleJobNumber(cookies,value)
                .then(work_schedule => {
                    setInProgress(false);
                    setInputs(values => ({...values, ['schedule_no']: work_schedule.schedule_no}));
                    getAllPlantConfigurations(cookies,value)
                    .then (
                        plantConfigList => {
                            setPlantConfig(plantConfigList);
                        }
                    )
                })
                .catch((error) =>
                {
                    setInProgress(false);
                    // console.log(error.response.data);
                    displayError(error.response.data," Failed");
                })
            } else if (name === 'plant_id' && !value) {
                setInputs(values => ({...values, ['schedule_no']: ''}));
                setPlantConfig({})
            }
            // Important : Code for validity date change depending on delivery date 
            // else if (name === 'delivery_date')
            // {
            //     // Parse the delivery date string to a Date object
            //     var deliveryDate = new Date(value);
            //     console.log(deliveryDate+"deliveryDate");

            //     // Add 1 day to the delivery date
            //     var validityDate = new Date(deliveryDate);
            //     console.log(validityDate+"validityDate");
            //     validityDate.setDate(deliveryDate.getDate() + 1);

            //     // Format the validity date as YYYY-MM-DD
            //     console.log(validityDate.toISOString()+"validityDate.toISOString()")
            //     var formattedValidityDate = validityDate.toISOString().split('T')[0];
            //     console.log(formattedValidityDate+"formattedValidityDate");
            //     setInputs(values => ({...values, ['validity_date']: formattedValidityDate}));
            // }
        }
        catch (e) {
            displayErrorToast(e);
        }
    }

    const clearSalesOrderSelection = () => {
        setSelectedSalesOrder({});
        setSalesorders([]);
        setAllSalesOrders([]);
        setProducts([]);
        setDeliveryModes([]);
        setFilteredPlants([]);
        setDesignMixList({});
        setData({ total_pages: 0, records: [] });
        setInputs(values => ({
            ...values,
            salesorder_id: '',
            sales_order_detail_id: '',
            plant_id: '',
            schedule_no: '',
            order_quantity: '',
            balance_qty: '',
            delivery_mode: '',
            validity_date: '',
        }));
    };

    const onCustomerSelect = (selected) => {
        setSelectedCustomerOption(selected);
        const customerId = selected?.value || '';
        setInputs(values => ({ ...values, customer_id: customerId }));
        clearSalesOrderSelection();
    };
  
const applyProductLineSelection = (sales_order_detail_id, salesOrder) => {
    const DM_MANUAL = 'manual';
    const DM_PUMP = 'pump';
    const DM_MANUAL_OR_PUMP = 'manual/pump';

    if (!sales_order_detail_id || !salesOrder) {
        setDesignMixList({});
        setDeliveryModes([]);
        setInputs(values => ({ ...values, sales_order_detail_id: sales_order_detail_id || '' }));
        return;
    }

    const selected_product = salesOrder.order_list.find((order) => order.id == sales_order_detail_id);
    if (!selected_product) {
        return;
    }

    const balanceQty = selected_product.quantity - selected_product.delivered_qty;
    setInputs(values => ({
        ...values,
        sales_order_detail_id,
        delivery_mode: (selected_product.delivery_mode === DM_MANUAL_OR_PUMP ? '' : selected_product.delivery_mode),
        order_quantity: selected_product.quantity,
        balance_qty: balanceQty,
    }));

    getDefaultDesignMix(cookies, sales_order_detail_id)
        .then((designmix_list) => setDesignMixList(designmix_list));

    const scheduledQtyEl = document.getElementById('scheduled_qty');
    if (scheduledQtyEl) {
        scheduledQtyEl.max = balanceQty;
    }

    if (selected_product.delivery_mode === DM_MANUAL_OR_PUMP) {
        setDeliveryModes([
            { value: '', label: 'Please select Delivery Mode' },
            { value: DM_MANUAL, label: DM_MANUAL.toUpperCase() },
            { value: DM_PUMP, label: DM_PUMP.toUpperCase() },
        ]);
    } else {
        setDeliveryModes([
            { value: selected_product.delivery_mode, label: selected_product.delivery_mode.toUpperCase() },
        ]);
    }
};

const handleChangeSalesOrderDetails = (salesOrderDetailId) => {
    if (!salesOrderDetailId) {
        setShowModal(false);
        return;
    }

    const { salesorder: selected_so, line: selected_line } = findSalesOrderLine(allSalesOrders, salesOrderDetailId);
    if (!selected_so || !selected_line) {
        setShowModal(false);
        return;
    }

    setSelectedSalesOrder(selected_so);
    setProducts(getFinishedGoodsLines(selected_so).map((order) => ({
        value: order.id,
        label: order.product.name,
    })));
    setInputs(values => ({
        ...values,
        salesorder_id: selected_so.id,
        sales_order_detail_id: '',
        validity_date: getDisplayDate(selected_so.validity_date),
    }));
    applyProductLineSelection(selected_line.id, selected_so);

    const plants = (selected_so.plants || []).map((plant) => ({
        value: plant.id,
        label: plant.alias,
    }));
    if (plants.length) {
        setFilteredPlants(plants);
    } else if (selected_so.company?.id) {
        getCompanyDetails(cookies, selected_so.company.id)
            .then((company) => {
                setFilteredPlants((company.plants || []).map((plant) => ({
                    value: plant.id,
                    label: plant.alias,
                })));
            })
            .catch((error) => {
                displayError(error.response?.data ?? error.message, 'Failed to load company plants');
            });
    }

    setShowModal(false);
}; 

const showDesignMixTable = () =>{
//     console.log(JSON.stringify(designMixList)+"designMixList dmix button ");
//     console.log(JSON.stringify(plantConfig)+"plantConfig dmix button");
//     console.log(Object.keys(designMixList).length, "designMixList length");
// console.log(Object.keys(plantConfig).length, "plantConfig length");
    // if ((Object.keys(designMixList).length>0) && (Object.keys(plantConfig).length>0)) {
    if((plantConfig.plant_configuration_list &&
        plantConfig.plant_configuration_list.length > 0 &&
        designMixList.design_mix_list &&
        designMixList.design_mix_list.length > 0) ){
            showDmixPopup(designMixList, plantConfig, cookies, {
              plantId: inputs.plant_id,
              plantAlias: filteredplants.find((p) => String(p.value) === String(inputs.plant_id))?.label,
            })
    }
  }
 
    const handleChangeProductDetails = (event) => {
        applyProductLineSelection(event.target.value, selectedSalesOrder);
    }; 
   
    const navigate = useNavigate();
    const handleChangeCementDisplyed = (event) =>{
        const name = event.target.name;
        const value = event.target.value;
        const FIELD_CEMENT_NAME='cement_name';
        if(value === 'false'){
           document.getElementById(FIELD_CEMENT_NAME).disabled = true;
           document.getElementById(FIELD_CEMENT_NAME).required = false;
           document.getElementById(FIELD_CEMENT_NAME).className = document.getElementById(FIELD_CEMENT_NAME).className.replace('mandatory-form-control',''); 
        }
        else
        {
            document.getElementById(FIELD_CEMENT_NAME).disabled = false;
            document.getElementById(FIELD_CEMENT_NAME).required = true;
            document.getElementById(FIELD_CEMENT_NAME).className += ' mandatory-form-control'; 
        }
        setInputs(values => ({...values, [name]: event.target.value}))
    }

    const showCustomerDetails = () => {
        if (selectedSalesOrder.id) {
            getCustomerMainDetails(cookies,selectedSalesOrder.consignee.customer.id)
            .then(selectedCustomer => {
                Swal.fire({
                    html:getHTMLForSummaryPopup(
                        'BILLING DETAILS',
                        [
                        {label: 'ADDRESS', value: selectedCustomer.address_1},
                        {value: selectedCustomer.address_2},
                        {value: selectedCustomer.address_3},
                        {label: 'GST', value: selectedCustomer.gst_no},
                        {label: 'PAN', value: selectedCustomer.pan_no},
                        {label: 'SALES OFFICER', value: selectedCustomer.salesrep.name},
                        {label: 'CREDIT LIMIT', value: selectedCustomer.credit_limit}
                        ])
                }, '', 'info');
            })
        }
    }

    const showSiteDetails = () => {
        if (selectedSalesOrder.id) {
            getCustomerSiteDetails(cookies,selectedSalesOrder.consignee.id)
            .then(consignee => {
                Swal.fire({
                    html:getHTMLForSummaryPopup(
                        'SITE DETAILS',
                        [
                        {label: 'ADDRESS', value: consignee.address_1},
                        {value: consignee.address_2},
                        {value: consignee.address_3},
                        {label: 'SITE NAME', value: consignee.name},
                        {label: 'CONTACT NAME', value: consignee.contact_person},
                        {label: 'MOBILE NO', value: consignee.contact_mobile_no},
                        {label: 'DESIGNATION', value: consignee.contact_designation}
                        ])
                }, '', 'info');   
            })
        }
    }
    const showSalesOrderDetails = () => {
        if (selectedSalesOrder.id) {
                Swal.fire({
                    html:getHTMLForSummaryPopup(
                        'SALESORDER DETAILS',
                        [
                        {label: 'SO DATE', value: selectedSalesOrder.order_date},
                        {label: 'MODE OF TRANSPORT', value: selectedSalesOrder.transport_mode},
                        {label: 'DELIVERY DATE', value: selectedSalesOrder.delivery_date},
                        {label: 'REMARKS', value: selectedSalesOrder.user_remarks}
                        ])
                }, '', 'info');   
        }
    }

    const constructFormData = () => {
        const EMPTY_STRING = '';
        return {
            plant_id:parseInt(inputs.plant_id) ,
            sales_order_detail_id:parseInt(inputs.sales_order_detail_id),
            schedule_no: inputs.schedule_no,
            schedule_date:getDisplayDate(inputs.schedule_date),
            is_name_req:parseBoolean(inputs.is_name_req),
            cement_name: inputs.cement_name,
            delivery_date:getDisplayDate(inputs.delivery_date),
            validity_date:getDisplayDate(inputs.validity_date),
            delivery_time:inputs.delivery_time,
            scheduled_qty:parseFloat(inputs.scheduled_qty),
            is_extra_shut_required:parseBoolean(inputs.is_extra_shut_required),
            delivery_mode: inputs.delivery_mode,
            slump1: parseInt(inputs.slump1)?parseInt(inputs.slump1):0,
            slump2: parseInt(inputs.slump2)?parseInt(inputs.slump2):0,
            cube_mould_test_place: inputs.cube_mould_test_place,
            status:parseBoolean(inputs.status)
        }
    } 
 
   //If all the required fields are field u can select the save button then choose the option yes or no
    const handleSubmit = (event) => {
        event.preventDefault()
        try{
            if ((Object.values(error).every(x => !x)) && isSubmitting) { 
                Swal.fire({title: 'Do you want to save?',  
                showCancelButton: true,  
                confirmButtonText: `Yes`,  
                cancelButtonText: `No`,
                }).then((result) => {  
                    if (result.isConfirmed) 
                    { 
                        setInProgress(true);
                        createWorkSchedule(cookies, constructFormData())
                        .then(function (response) {
                            setInProgress(false);
                            Swal.fire('Saved!', '', 'success') 
                            Reload();
                        })
                        .catch((error) =>
                        {
                            console.log(error);
                            setInProgress(false);
                        // console.log(error.response.data);
                        displayError(error.response.data,"Save Failed");
                        })
                    
                    }
                    else if (result.isDismissed) 
                    {    
                    Swal.fire('Not saved', '', 'info')  
                    }
                });
            }
        }
        catch (e) {
                displayErrorToast(e);
            }
    }
           
    const Reload = () => {
        window.location.reload();
    } 

    const view = () => {
        navigate('/WorkScheduleTable')
    } 

    const Back = () => {
        navigate('/Home')
    }

    const Cancel = () => {
        setInputs(() => "")
        navigate(location.pathname, { replace: true });
    }
    
    const applySalesOrderPickerData = (activeSalesOrders) => {
        const salesorderOptions = activeSalesOrders.map(salesorder => ({
            value: salesorder.id,
            label: `${salesorder.prefix || ''}${salesorder.order_no || ''}`,
        }));
        setSalesorders(salesorderOptions);
        setAllSalesOrders(activeSalesOrders);

        const tableData = activeSalesOrders.flatMap(buildSalesOrderPopupRow);

        setData({
            total: tableData.length,
            records: tableData,
        });

        if (tableData.length === 0) {
            setShowModal(false);
            Swal.fire('No sales orders available for work schedule.', '', 'info');
            return;
        }
        setShowModal(true);
    };

    const Help = () => {
        if (!inputs.customer_id) {
            Swal.fire('Please select a Customer first.', '', 'warning');
            return;
        }

        setShowModal(true);
        const cachedOrders = salesOrderCacheRef.current[inputs.customer_id];
        if (cachedOrders) {
            setIsModalLoading(false);
            applySalesOrderPickerData(cachedOrders);
            return;
        }

        setIsModalLoading(true);
        getSalesOrdersForWorkSchedule(cookies, inputs.customer_id)
            .then(salesorderList => {
                const activeSalesOrders = (salesorderList?.sales_order_list || []).filter(obj => obj.status);
                salesOrderCacheRef.current[inputs.customer_id] = activeSalesOrders;
                setIsModalLoading(false);
                applySalesOrderPickerData(activeSalesOrders);
            })
            .catch((error) => {
                setIsModalLoading(false);
                setShowModal(false);
                displayError(error.response?.data ?? error.message, 'Failed to load sales orders');
            });
    }
    const Close = () => {
        setShowModal(false)
      }
    const columns =
        useMemo(
            () => [
                {
                    fieldName: "id",
                    headerName: "ROW_ACTIONS",
                    size: 56,
                    minSize: 56,
                },
                {
                    fieldName: 'order_no',
                    headerName: 'SO No',
                    size: 150,
                    minSize: 130,
                },
                {
                    fieldName: 'order_date',
                    headerName: 'SO Date',
                    size: 110,
                    minSize: 100,
                },
                {
                    fieldName: 'validity_date',
                    headerName: 'Validity Date',
                    size: 120,
                    minSize: 110,
                },
                {
                    fieldName: 'company',
                    headerName: 'Company',
                    size: 200,
                    minSize: 170,
                    wrap: true,
                },
                {
                    fieldName: "customer_name",
                    headerName: 'Customer',
                    size: 240,
                    minSize: 200,
                    wrap: true,
                },
                {
                    fieldName: "consignee_name",
                    headerName: 'Site',
                    size: 160,
                    minSize: 120,
                },
                {
                    fieldName: 'grade',
                    headerName: 'Grade',
                    size: 90,
                    minSize: 70,
                },
                {
                    fieldName: 'delivery_mode',
                    headerName: 'Mode of Delivery',
                    size: 140,
                    minSize: 120,
                },
                {
                    fieldName: 'order_qty',
                    headerName: 'Order Qty',
                    size: 90,
                    minSize: 80,
                    align: 'right'
                },
                {
                    fieldName: 'balance_qty',
                    headerName: 'Balance Qty',
                    size: 110,
                    minSize: 90,
                    align: 'right'
                }
    ],
    [],);

    const summaryCards = useMemo(() => {
        const salesOrderLabel = selectedSalesOrder?.order_no
            ? `${selectedSalesOrder.prefix || ''}${selectedSalesOrder.order_no || ''}`
            : '—';
        const gradeLabel = products.find(
            (item) => String(item.value) === String(inputs.sales_order_detail_id)
        )?.label || '—';
        const orderQty = inputs.order_quantity !== '' && inputs.order_quantity != null
            ? formatQty(inputs.order_quantity)
            : '—';
        const balanceQty = inputs.balance_qty !== '' && inputs.balance_qty != null
            ? formatQty(inputs.balance_qty)
            : '—';

        return [
            buildGradientCard('Sales Order', salesOrderLabel, 'blue'),
            buildGradientCard('Grade', gradeLabel, 'purple'),
            buildGradientCard('Order Qty', orderQty, 'teal'),
            buildGradientCard('Balance Qty', balanceQty, 'today'),
        ];
    }, [
        selectedSalesOrder,
        products,
        inputs.sales_order_detail_id,
        inputs.order_quantity,
        inputs.balance_qty,
    ]);
    
    return (
        <>
            <div id="outer-container"  className="App" > 
                <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
                <ErrorToast/>
                <LoadingOverlay inProgress={inProgress}/>
                <div id="page-wrap">
                    <ListFormPageHeader
                        module="PLANNING"
                        title="Work Schedule"
                        subtitle="Create a delivery schedule for the selected sales order."
                        modeLabel="CREATE MODE"
                        headerActions={summaryCards.map((card) => (
                            <GradientCard key={card.label} card={card} />
                        ))}
                    />
                    <div className="list-form-page-shell">
                    <form onSubmit={handleSubmit} >
                        <FloatingControls
                            tableLink="/WorkScheduleTable"
                            onCancel={Cancel}
                            enableCancel={true}
                            formLink="/WorkSchedule"
                            addNewLabel="New Work Schedule"
                        />
                    <div className="container form-control-panel">
                        <Row> 
                        <Col xl={12} lg={12} md={6} >   
                            <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3  form-control-panel " >
                                                           
                                {/* <button type="button"  onClick={Help} className="btn btn-primary text-blue text-bold rounded-circle rounded-sm">
                                <i className="fa fa-solid fa-question"></i> 
                                </button> */}
                            <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                                                        <div className="modal-dialog modal-xl so-picker-modal-dialog">
                                                        <div className="modal-content">
                                                            <div className="modal-body display">
                                                            <div className="container item-list-table-container so-picker-table-wrap">
                                                                        <ReactTablePopUpSubmitWrapper
                                                                            title='Select Sales Order'
                                                                            columns={columns}
                                                                            data={data.records}
                                                                            onRowSubmit={handleChangeSalesOrderDetails}
                                                                            isLoading={isModalLoading}
                                                                            onClose = {Close}
                                                                            enableDetailPanel={false}
                                                                            initialPageSize={15}
                                                                            compactRows={false}
                                                                        />
                                                                </div> 
                                                            </div>
                                                        </div>
                                                        </div>
                                </div>
                            <label htmlFor="customer_id" className="form-group col-sm-2 text-right">Customer</label>
                            <div className="col-sm-3 px-0 ws-customer-select">
                                <ReactSelect
                                    id="customer_id"
                                    options={customers}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={selectedCustomerOption}
                                    onChange={onCustomerSelect}
                                    placeholder="Type to select..."
                                    className="mandatory-form-control"
                                    title={selectedCustomerOption?.label || ''}
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    menuPosition="fixed"
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      control: (base) => ({ ...base, minHeight: 31, width: '100%' }),
                                      valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                      singleValue: (base) => ({ ...base, maxWidth: 'calc(100% - 8px)' }),
                                    }}
                                />
                            </div>

                            <label htmlFor="salesorder_id" className="form-group col-sm-3 text-right"> Sales Order</label>
                                <div className="col-sm-3 px-0 form-input-with-icon">
                                  <select id="salesorder_id" name="salesorder_id" className="form-control" value={inputs.salesorder_id || ""} disabled={true}>
                                  <option value=""></option>
                                      {salesorders.map((item) => (
                                          <option key={item.value} value={item.value}>
                                              {item.label}</option>
                                      ))}
                                  </select>
                                  <QuestionIcon onClickHandler={Help}/>
                                  <SummaryIcon onClickHandler={showSalesOrderDetails}/>
                                </div>
                                                <br/>

                                                <ViewOnlyTextbox 
                                                name="company_name" 
                                                value={selectedSalesOrder?.company?.name || ""}
                                                labelClassName="form-group col-sm-2 text-right"
                                                label="Company Name"
                                                inputClassName="form-control col-sm-3"
                                                />

                                                <ViewOnlyTextbox 
                                                name="billing_name" 
                                                value={selectedSalesOrder?.consignee?.customer?.name || ""}
                                                labelClassName="form-group col-sm-3 text-right"
                                                label="Billing Name"
                                                inputClassName="form-control col-sm-3"
                                                showSummaryDetails={showCustomerDetails}
                                                /> 
                                                <br/>

                                                <ViewOnlyTextbox 
                                                name="purchase_order_no" 
                                                value={selectedSalesOrder?.purchase_order_no || ""}
                                                labelClassName="form-group col-sm-2 text-right"
                                                label="Purchase Order No"
                                                inputClassName="form-control col-sm-3"
                                                />

                                                <ViewOnlyTextbox 
                                                name="ship_to" 
                                                value={selectedSalesOrder?.consignee?.project_name|| ""}
                                                labelClassName="form-group col-sm-3 text-right"
                                                label="Ship To"
                                                inputClassName="form-control col-sm-3"
                                                showSummaryDetails={showSiteDetails}
                                                />    
                                                <br/>

                                                <ViewOnlyTextbox 
                                                name="order_date" 
                                                value={selectedSalesOrder?.order_date || ""}
                                                labelClassName="form-group col-sm-2 text-right"
                                                label="Order Date"
                                                inputClassName="form-control col-sm-3"
                                                />    
                            </div>
                        </Col>
                    </Row>
                    <div className="container form-control-panel">
                    <h5 style={{paddingTop:"20px"}}><b>SCHEDULE DETAILS </b>
                    {((plantConfig.plant_configuration_list &&
                                    plantConfig.plant_configuration_list.length > 0 &&
                                    designMixList.design_mix_list &&
                                    designMixList.design_mix_list.length > 0) && 
                                   <DmixIcon onClickHandler={showDesignMixTable}/>
                                 )} 
                    </h5>  
                    
                    <Row> 
                
                        <Col xl={6} lg={12} md={12}> 
                        
                        <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3  form-control-panel" >
                                
                                <label htmlFor="plant_id" className="form-group col-sm-4 text-right"> Plant Location: </label>
                                <select id="plant_id"name="plant_id" className="form-control col-sm-7  browser-default custom-select  mandatory-form-control"  required onChange={handleChange} value={inputs.plant_id || ""}>
                                <option value="">Select plant</option>
                                
                                    {filteredplants.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}</option>
                                    ))}
                                </select>

                                <label htmlFor="sales_order_detail_id" className="form-group col-sm-4 text-right"> Grade</label>
                                <select id="sales_order_detail_id"name="sales_order_detail_id" className="form-control col-sm-7  browser-default custom-select  mandatory-form-control"  required onChange={  handleChangeProductDetails } value={inputs.sales_order_detail_id || ""}>
                                <option value="">Select Products</option>
                                    {products.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}</option>
                                    ))}
                                </select>
                               
                                <label htmlFor="delivery_mode" className="form-group col-sm-4 text-right">Mode of Delivery</label>
                                <select className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.delivery_mode || ""} name="delivery_mode"  id="delivery_mode">
                                {deliverymodes.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}</option>
                                            ))}
                                </select>

                            
                                <label htmlFor="delivery_date" className="form-group col-sm-4 text-right">Delivery Date </label>
                                <input type="date" id="delivery_date"required name="delivery_date" onChange={handleChange} value={inputs.delivery_date || ""}className="form-control col-sm-7 mandatory-form-control"/>
                                <label htmlFor="delivery_time" className="form-group col-sm-4 text-right">Delivery Time </label>
                                <input type="time"id="delivery_time" name="delivery_time" required onChange={handleChange} value={inputs.delivery_time || ""}className="form-control col-sm-7 mandatory-form-control"/><br/>
                                <label htmlFor="scheduled_qty" className="form-group col-sm-4 text-right">Schedule Qty </label>
                                <input type="number" id="scheduled_qty"step="any" onChange={handleChange} value={inputs.scheduled_qty || ''}className="form-control col-sm-7 mandatory-form-control" required name="scheduled_qty"/>
                                {/*  min="1" max ="4" */}
                                <label htmlFor="is_extra_shut_required" className="form-group col-sm-4 text-right">Is Extra Chute Required? </label>
                            <select className="form-control col-sm-7 browser-default custom-select" required onChange={handleChange} value={inputs.is_extra_shut_required || ""}name="is_extra_shut_required" id="is_extra_shut_required">
                                {/* <option value="">Please select</option> */}
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                
                            <label htmlFor="cube_mould_test_place" className="form-group col-sm-4 text-right">Cube Mould Test @ </label>
                            <select id="cube_mould_test_place"className="form-control col-sm-7 browser-default custom-select"  onChange={handleChange} value={inputs.cube_mould_test_place || ""}   name="cube_mould_test_place">
                                {/* <option value="">Please select</option> */}
                                <option value="plant">Plant</option>
                                <option value="site">Site</option>
                                <option value="plant_and_site">Plant and Site</option>
                            </select>
                            
                            <label htmlFor="slump1" className="form-group col-sm-4 text-right">Slump @ Plant / Site</label>
                            <input type="number" name="slump1"  onChange={handleChange} value={inputs.slump1 || 0}  className="form-control col-sm-4" />
                            <input type="number" name="slump2"  onChange={handleChange} value={inputs.slump2 || 0} className="form-control col-sm-3" />     

                            <label htmlFor="is_name_req" className="form-group col-sm-4 text-right">Is Cement name to be displayed in DC? </label>
                                <select className="form-control col-sm-7 browser-default custom-select"id="is_name_req"onChange={handleChangeCementDisplyed} value={inputs.is_name_req || 'false'} required name="is_name_req">
                                {/* <option value=""></option> */}
                                    <option value="false">No</option>
                                    <option value="true">Yes</option>
                                </select>
                                <label htmlFor="cement_name" className="form-group col-sm-4 text-right">Cement Name</label>
                                <input type="text" className="form-control col-sm-7"onChange={handleChange} value={inputs.cement_name || ""} id="cement_name"  name="cement_name" disabled={true} />       
                                
                            </div>   
                        </Col>
                    
                        <Col xl={6} lg={12} md={12}> 
                        
                        <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3  form-control-panel">
                        <label htmlFor="schedule_no" className="form-group col-sm-4 text-right">Job No</label>
                                <input type="text" className="form-control col-sm-7" id="schedule_no"value={inputs.schedule_no || ""} readOnly={true} style={{cursor: "not-allowed"}} name="schedule_no" disabled={true}/><br/>
                                <label htmlFor="schedule_date" className="form-group col-sm-4 text-right">Job Date</label>
                                <input type="date" className="form-control col-sm-7 mandatory-form-control" id="schedule_date"value={inputs.schedule_date || getCurrentDate()} name="schedule_date" required onChange={handleChange} /><br/>
                                <label htmlFor="order_quantity" className="form-group col-sm-4 text-right">Order Qty.</label>
                                <input type="number" className="form-control col-sm-7" readOnly={true} style={{ cursor: "not-allowed"}}  disabled ={true}  value={inputs.order_quantity || ""}  />
                                    {/* value="{{sales.soDOrdQty}}" */}
                                <label htmlFor="balance_qty" className="form-group col-sm-4 text-right">Balance Qty.</label>
                                <input type="number" value={inputs.balance_qty || ""} name="balance_qty" id="balance_qty" readOnly={true} className="form-control col-sm-7"  disabled ={true}  style={{ cursor: "not-allowed"}}/>
                                
                                <label htmlFor="validity_date" className="form-group col-sm-4 text-right">Validity Date </label>
                                <input type="date" id="validity_date" name="validity_date"  value={inputs.validity_date || ""} className="form-control col-sm-7" onChange={handleChange}/>
                                
                                <StatusDropDown status={inputs.status} onChange={handleChange}/><br/>
                                <label className="form-group col-sm-3 text-right"> </label>
                                
                                
                                  {/* (Object.keys(designMixList).length>0) && (Object.keys(plantConfig).length>0) */}
                                
                        </div>
                        </Col>
                    </Row> 
                    </div>                               
                    </div>
                    <div className="footer text-center">
                        <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Save</Button> &nbsp;&nbsp;
                        <Button type="reset" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} onClick={Cancel}>Reset</Button> &nbsp;&nbsp;
                        <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>&nbsp;&nbsp;
                        <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>Home</Button>
                    </div>
                </form>
                    </div>
                </div>
            </div>
        </>
    );
  }
  export default WorkSchedule;